import { h } from 'preact';
export const Hash = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("line", { x1: "4", y1: "9", x2: "20", y2: "9" }),
        h("line", { x1: "4", y1: "15", x2: "20", y2: "15" }),
        h("line", { x1: "10", y1: "3", x2: "8", y2: "21" }),
        h("line", { x1: "16", y1: "3", x2: "14", y2: "21" })));
};
//# sourceMappingURL=hash.js.map